module.exports = "<div class=\"leaflet-control control obs-map-context-info\"> <p class=ref-label>{{referenceLabel}}</p> <div class=\"val ref-val\">{{reference.name}} : {{referenceValue}}</div> <p class=moy-label>Moyennes</p> <div class=\"val moy-val\" ng-if=\"strate!=null\">{{strate}} : {{strateValue}}</div> <div class=\"val moy-val\">Département ({{departementCodeInsee}}) : {{departementValue}}</div> <div class=\"val moy-val\">Nationale : {{paysValue}}</div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/observatoire/ng/maps/commune/obsCommuneMapContextInfo.html
// module id = 884
// module chunks = 2 11 12